import { IOAuthStrategy } from '@wix/sdk';
import { resolveContext } from '@wix/sdk-runtime/context';

export const resolveAuthToken = () => {
  return resolveContext()?.getAuth<IOAuthStrategy>().getTokens().accessToken
    .value;
};
